module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-detail/quota-detail.component.css
// module id = ./src/app/quotas/quota-detail/quota-detail.component.css
// module chunks = main